/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import useGetPageDetails, { removePageDetailsFromCookie } from "@MasterBluePrint/Common/Hooks/useCurrentPageDetails";
import {
    addWishListToCart as addWishListToCartApi,
    AddWishListToCartApiParameter,
} from "@MasterBluePrint/Overrides/Services/CartService";

/* istanbul ignore next */
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain, RequestDataFromApi, async (props: any) => {
    const result = await addWishListToCartApi(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
});
addToChainBefore(chain, RequestDataFromApi, props => {
    useGetPageDetails(props.getState());
});
addToChainAfter(chain, RequestDataFromApi, props => {
    removePageDetailsFromCookie();
});